import { Directive, HostListener, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[focusInvalidInput]'
})
export class FocusInvalidInputDirective implements AfterViewInit{
  focusables = ['input', 'textarea']
  focusablesWitherror = ['input', 'textarea', 'select', 're-captcha']
  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    const input = this.el.nativeElement.querySelector(
      this.focusables.join(','),
    )
    if (input) {
      input.focus()
    }
  }

  @HostListener('submit')
  submit() {
    const input = this.el.nativeElement.querySelector(
      [
        ...this.focusablesWitherror.map((element) => `${element}.ng-invalid`),
        '#myce_search_school-input.c11n-input__input',
        'c11n-dropdown.c11n-dropdown--untouched'
      ].join(','),
    )
    if (input) {
      if (input.type === 'radio' || input.type === 'checkbox') {
        input.scrollIntoView({block: 'center'})
        input.focus()
      } else if (input.classList.contains('c11n-dropdown--untouched')) {
        const childDiv = input.querySelector('div');
        if (childDiv) {
          const childButton = childDiv.querySelector('button.c11n-dropdown__trigger.c11n-menu__trigger');
          if (childButton) {
            childButton.focus();
          }
        }
      } else {
        input.focus()
      }
    }
  }
}
